import { Link } from "react-router-dom";
import { MoreHorizontal } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// "Altro ⋯" menu: items = [{ label, icon, onClick | to, danger, testid }] ; null = separator
export const MoreMenu = ({ items, testid, label = "Altro", className = "" }) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <button className={`inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-[#212530] hover:bg-[#2A2E3D] text-sm px-3 h-9 transition-colors ${className}`} data-testid={testid} aria-label={label}>
        <MoreHorizontal className="w-4 h-4" /><span className="hidden sm:inline">{label}</span>
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="min-w-[220px] bg-[#181A22] border-[#2A2E3D] text-white">
      {items.filter((it) => it !== false).map((it, i) => {
        if (it === null) return <DropdownMenuSeparator key={`s${i}`} className="bg-white/10" />;
        const I = it.icon;
        const inner = <>{I && <I className="w-4 h-4 mr-2" />}{it.label}</>;
        const cls = `cursor-pointer py-2.5 ${it.danger ? "text-[#F87171] focus:text-[#F87171] focus:bg-[#E63946]/15" : "focus:bg-white/10"}`;
        return it.to ? (
          <DropdownMenuItem key={it.label} asChild className={cls} data-testid={it.testid}><Link to={it.to}>{inner}</Link></DropdownMenuItem>
        ) : (
          <DropdownMenuItem key={it.label} onSelect={it.onClick} className={cls} data-testid={it.testid}>{inner}</DropdownMenuItem>
        );
      })}
    </DropdownMenuContent>
  </DropdownMenu>
);
